module.exports = __webpack_public_path__ + "img/produktbroschuren_nl.30594f40.png";